// extracted by mini-css-extract-plugin
export default {"text-medium":"text-medium_text-medium__jNXP0","required":"text-medium_required__uOM6K"};